import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";

import { HomeComponent } from "./components/home/home.component";
import { AboutUsComponent } from "./components/about-us/about-us.component";
import { OurPartnersComponent } from "./components/our-partners/our-partners.component";
import { TechnologyComponent } from "./components/technology/technology.component";
import { FashionSustainabilityComponent } from "./components/fashion-sustainability/fashion-sustainability.component";
import { MediaComponent } from "./components/media/media.component";
import { TalentComponent } from "./components/talent/talent.component";
import { ContactUsComponent } from "./components/contact-us/contact-us.component";
import { VisionComponent } from "./components/about-us/vision/vision.component";
import { StrategyComponent } from "./components/about-us/strategy/strategy.component";
import { FashionContactComponent } from "./components/fashion-sustainability/fashion-contact/fashion-contact.component";
import { FashionVideoComponent } from "./components/fashion-sustainability/fashion-video/fashion-video.component";
import { EquilibriumLifeComponent } from "./components/equilibrium-life/equilibrium-life.component";
import { BusinessCombinationComponent } from "./components/media/business-combination/business-combination.component";
import { PresentationAnalysisReportComponent } from "./components/presentation-analysis-report/presentation-analysis-report.component";
import { SmxSecFilingsComponent } from "./components/smx-sec-filings/smx-sec-filings.component";
import { NewsroomComponent } from "./components/newsroom/newsroom.component";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "home", component: HomeComponent },
  { path: "about-us", component: AboutUsComponent },
  { path: "our-partners", component: OurPartnersComponent },
  { path: "technology", component: TechnologyComponent },
  { path: "fashion-sustainability", component: FashionSustainabilityComponent },
  { path: "equilibrium-life", component: EquilibriumLifeComponent },
  { path: "media", component: MediaComponent },
  { path: "newsroom", component: NewsroomComponent },

  {
    path: "media/business-combination",
    component: BusinessCombinationComponent,
  },
  { path: "talent", component: TalentComponent },
  { path: "contact-us", component: ContactUsComponent },
  { path: "vision", component: VisionComponent },
  { path: "our-strategy", component: StrategyComponent },
  { path: "fashion-contact", component: FashionContactComponent },
  { path: "fashion-video", component: FashionVideoComponent },
  {
    path: "fashion-sustainability/fashion-contact",
    redirectTo: "fashion-contact",
    pathMatch: "full",
  },
  {
    path: "fashion-sustainability/fashion-video",
    redirectTo: "fashion-video",
    pathMatch: "full",
  },
  {
    path: "presentation-analysis-report",
    component: PresentationAnalysisReportComponent,
  },
  {
    path: "sec-filings",
    component: SmxSecFilingsComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: false,
    }),
  ],
  exports: [],
})
export class AppRoutingModule {}
